var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_w-max _pc-pad-y-75 _flex-col"},[_c('div',{staticClass:"animate__animated animate__bounceInUp"},[_c('AboutUs')],1),_c('div',{class:_vm.scrollTop > 500 ? 'animate__animated animate__fadeInLeft' : ''},[_c('Contact')],1),_c('div',{class:_vm.scrollTop > 1500 ? 'animate__animated animate__fadeInRight' : ''},[_c('Message')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }